import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=3002c0de&scoped=true&"
import script from "./addProductType.vue?vue&type=script&lang=js&"
export * from "./addProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002c0de",
  null
  
)

export default component.exports